import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productData, setProductData] = useState({
    name: "",
    code:"",
    subcategory_id: "",
    variants: [],
  });

  const [subcategories, setSubcategories] = useState([]);
  const [branches, setBranches] = useState([]);

  // Fetch subcategories and branches only once
  useEffect(() => {
    axios.get("https://agaram.ematixsolutions.com/api/subcategories").then((res) => {
      setSubcategories(res.data);
    });

    axios.get("https://agaram.ematixsolutions.com/api/branches").then((res) => {
      setBranches(res.data);
    });
  }, []);

  // Fetch product data every time id changes
  useEffect(() => {
    // Clear productData first to avoid duplication issues
    setProductData({ name: "", subcategory_id: "", variants: [] });

    axios
      .get(`https://agaram.ematixsolutions.com/api/products/${id}`)
      .then((res) => {
        const data = res.data.product;

        // Map variants, add stable 'key' using variant id
        const variantsWithKeys = data.variants.map((v) => ({
          key: v.id, // stable unique key
          size: v.size,
          unit: v.unit,
          mrp: v.mrp,
          rate: v.rate,
          stocks: v.stocks.map((s) => ({
            branch_id: s.branch_id,
            stock: s.stock,
          })),
        }));

        setProductData({
          name: data.name,
           code: data.code, // <-- add this
          subcategory_id: data.subcategory_id,
          variants: variantsWithKeys,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch product:", error);
      });
  }, [id]);

  const handleChange = (index, field, value) => {
    const updated = [...productData.variants];
    updated[index][field] = value;
    setProductData({ ...productData, variants: updated });
  };

  const handleStockChange = (variantIndex, stockIndex, field, value) => {
    const updatedVariants = [...productData.variants];
    updatedVariants[variantIndex].stocks[stockIndex][field] = value;
    setProductData({ ...productData, variants: updatedVariants });
  };

  const addStockEntry = (variantIndex) => {
    const updated = [...productData.variants];
    updated[variantIndex].stocks.push({ branch_id: "", stock: 0 });
    setProductData({ ...productData, variants: updated });
  };

  const updateProduct = async () => {
  const cleanedData = {
    ...productData,
    subcategory_id: parseInt(productData.subcategory_id),
    variants: productData.variants.map((v) => ({
      size: v.size,
      unit: v.unit,
      mrp: parseFloat(v.mrp),
      rate: parseFloat(v.rate),
      stocks: v.stocks
        .filter((s) => s.branch_id && s.stock !== "")
        .map((s) => ({
          branch_id: parseInt(s.branch_id),
          stock: parseInt(s.stock),
        })),
    })),
  };

  // Log the cleaned data in formatted JSON
  console.log("Cleaned Product Data:", JSON.stringify(cleanedData, null, 2));

  try {
    await axios.put(`https://agaram.ematixsolutions.com/api/products/${id}`, cleanedData);
    alert("Product updated successfully!");
    navigate("/dashboard");
  } catch (error) {
    console.error("Update failed:", error.response?.data || error.message);
    alert("Failed to update product. See console for details.");
  }
};


  const styles = {
    wrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f2f2f2",
      padding: "20px",
    },
    card: {
      backgroundColor: "#fff",
      padding: "30px",
      borderRadius: "10px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      width: "100%",
      maxWidth: "650px",
    },
    input: {
      width: "100%",
      padding: "10px",
      marginBottom: "12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    },
    select: {
      width: "100%",
      padding: "10px",
      marginBottom: "12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    },
    variantBox: {
      border: "1px solid #ddd",
      padding: "15px",
      borderRadius: "8px",
      marginBottom: "20px",
      backgroundColor: "#fafafa",
    },
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2>Edit Product</h2>

        <label>Subcategory</label>
        <select
          style={styles.select}
          value={productData.subcategory_id}
          onChange={(e) =>
            setProductData({ ...productData, subcategory_id: e.target.value })
          }
        >
          <option value="">Select Subcategory</option>
          {subcategories.map((sub) => (
            <option key={sub.id} value={sub.id}>
              {sub.name}
            </option>
          ))}
        </select>

        <label>Product Name</label>
        <input
          style={styles.input}
          type="text"
          value={productData.name}
          onChange={(e) => setProductData({ ...productData, name: e.target.value })}
        />
         <label>Product Code</label>
        <input
          style={styles.input}
          type="text"
          value={productData.code}
        onChange={(e) => setProductData({ ...productData, code: e.target.value })}
       
      />

        <h3>Variants</h3>
        {productData.variants.map((variant, index) => (
          <div key={variant.key} style={styles.variantBox}>
            <input
              type="text"
              placeholder="Size"
              value={variant.size}
              onChange={(e) => handleChange(index, "size", e.target.value)}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="Unit"
              value={variant.unit}
              onChange={(e) => handleChange(index, "unit", e.target.value)}
              style={styles.input}
            />
            <input
              type="number"
              placeholder="MRP"
              value={variant.mrp}
              onChange={(e) => handleChange(index, "mrp", e.target.value)}
              style={styles.input}
            />
            <input
              type="number"
              placeholder="Rate"
              value={variant.rate}
              onChange={(e) => handleChange(index, "rate", e.target.value)}
              style={styles.input}
            />

            <h4>Stock per Branch</h4>
            {variant.stocks.map((stockEntry, sIdx) => (
              <div
                key={`${variant.key}-stock-${sIdx}`}
                style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
              >
                <select
                  value={stockEntry.branch_id}
                  onChange={(e) =>
                    handleStockChange(index, sIdx, "branch_id", e.target.value)
                  }
                  style={{ ...styles.select, flex: 1 }}
                >
                  <option value="">Select Branch</option>
                  {branches.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  placeholder="Stock"
                  value={stockEntry.stock}
                  onChange={(e) =>
                    handleStockChange(index, sIdx, "stock", e.target.value)
                  }
                  style={{ ...styles.input, flex: 1 }}
                />
              </div>
            ))}
            <button
              onClick={() => addStockEntry(index)}
              style={{ marginBottom: "10px" }}
            >
              + Add Branch Stock
            </button>
          </div>
        ))}

        <button onClick={updateProduct} style={styles.input}>
          Update Product
        </button>
      </div>
    </div>
  );
}

export default EditProduct;
